import React from "react";
import styled from "styled-components";
import { Box } from "rebass";

const StyledWrap = props => <Wrap {...props}>{props.children}</Wrap>;

export default StyledWrap;

// Styled Components
const Wrap = styled(Box)`
  background: #f8fcff;
  border: 1px solid rgba(151, 151, 151, 0.06);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;
  position: relative;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/components/ui/StyledWrap.jsx